import React from "react";
import PropTypes from "prop-types";
// Material imports
import Popper from "@mui/material/Popper";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import makeStyles from "@mui/styles/makeStyles";

// Limitless imports
import Grid from "@limitless/modern/layout/Grid";
import Paper from "@limitless/modern/surfaces/paper/Paper";
import Typography from "@limitless/modern/data-display/typography/Typography";
import IconButton from "@limitless/modern/inputs/icon-button/IconButton";
import FilterIcon from "@limitless/icons/Filter";

const CommonFilterPoper = ({
    clickAwayClose,
    filterExists,
    title = "",
    label = "",
    clearFilters,
    children,
    Icon = <FilterIcon />
}) => {
    const classes = commonRatingFilter();
    const [filtersOpen, setFiltersOpen] = React.useState(false);
    const [childNode, setChildNode] = React.useState(null);

    React.useEffect(() => clickAwayClose ?? setFiltersOpen(false), [clickAwayClose]);

    const handleClick = event => {
        setChildNode(event.currentTarget);
        setFiltersOpen(previousOpen => !previousOpen);
    };

    return (
        <>
            <IconButton
                icon={Icon}
                label={label}
                onClick={handleClick}
                sx={{
                    color: theme =>
                        filterExists || filtersOpen ? theme.palette.primary.main : theme.palette.primary.dark
                }}
                id="iconButton"
            />
            <Popper
                placement="bottom-end"
                disablePortal
                open={filtersOpen}
                anchorEl={childNode}
                components={{ Root: Paper }}
                componentsprops={{ paper: { sx: { borderRadius: 1 } } }}
                className={classes.popper}
            >
                <ClickAwayListener onClickAway={() => setFiltersOpen(false)}>
                    <div>
                        <Grid container className={classes.containers} component={Paper} elevation={1}>
                            <Grid item xs={6}>
                                <Typography variant="subtitle2">{title}</Typography>
                            </Grid>
                            <Grid item xs={6} style={{ textAlign: "right", height: 24 }}>
                                {filterExists && (
                                    <Typography
                                        sx={{ textAlign: "end", cursor: "pointer" }}
                                        variant="textButton"
                                        color="primary.main"
                                        onClick={clearFilters}
                                    >
                                        Clear all
                                    </Typography>
                                )}
                            </Grid>
                            {children}
                        </Grid>
                    </div>
                </ClickAwayListener>
            </Popper>
        </>
    );
};
export const commonRatingFilter = makeStyles(() => ({
    popper: {
        maxWidth: 286,
        minWidth: 286,
        height: "auto",
        padding: 2,
        zIndex: 1
    },
    containers: {
        width: "100%",
        height: "100%",
        padding: 16,
        textAlign: "left",
        borderRadius: "8px"
    }
}));

CommonFilterPoper.propTypes = {
    clickAwayClose: PropTypes.bool,
    filterExists: PropTypes.bool,
    title: PropTypes.string,
    label: PropTypes.string,
    clearFilters: PropTypes.func,
    children: PropTypes.node,
    Icon: PropTypes.node
};

export default CommonFilterPoper;
